import { tokens } from '../../theme';

/** Shared DataGrid look for sage/walnut shell */
export const dataGridSx = {
  border: `1px solid ${tokens.border}`,
  borderRadius: '12px',
  backgroundColor: tokens.surface,
  fontFamily: "'Figtree', sans-serif",
  '& .MuiDataGrid-columnHeaders': {
    backgroundColor: tokens.bg,
    borderBottom: 'none',
    minHeight: '48px !important',
  },
  '& .MuiDataGrid-columnHeader': {
    borderRight: 'none',
  },
  '& .MuiDataGrid-columnSeparator': {
    display: 'none',
  },
  '& .MuiDataGrid-columnHeaderTitle': {
    fontWeight: 650,
    color: tokens.ink,
    fontSize: 13,
  },
  '& .MuiDataGrid-cell': {
    borderRight: 'none',
    borderBottom: `1px solid ${tokens.border}`,
    fontSize: 13,
    color: tokens.ink,
  },
  '& .MuiDataGrid-row:hover': {
    backgroundColor: 'rgba(91, 127, 94, 0.05)',
  },
  '& .MuiDataGrid-row.Mui-selected': {
    backgroundColor: 'rgba(91, 127, 94, 0.10)',
    '&:hover': { backgroundColor: 'rgba(91, 127, 94, 0.14)' },
  },
  '& .MuiDataGrid-footerContainer': {
    borderTop: `1px solid ${tokens.border}`,
    minHeight: '44px !important',
    maxHeight: 44,
    backgroundColor: tokens.bg,
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 4px 0 8px',
  },
  // Compact pagination — MUI Toolbar defaults to 56px + baseline alignment
  '& .MuiDataGrid-footerContainer .MuiToolbar-root, & .MuiTablePagination-toolbar': {
    alignItems: 'center',
    minHeight: '44px !important',
    height: 44,
    paddingLeft: 8,
    paddingRight: 4,
    gap: 2,
  },
  '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
    margin: 0,
    padding: 0,
    lineHeight: 1.25,
    fontSize: 13,
    color: tokens.inkMuted,
    display: 'flex',
    alignItems: 'center',
  },
  '& .MuiTablePagination-input': {
    margin: '0 4px 0 0',
  },
  '& .MuiTablePagination-select': {
    margin: 0,
    paddingTop: 2,
    paddingBottom: 2,
    paddingRight: '24px !important',
    fontSize: 13,
    fontWeight: 600,
    color: tokens.ink,
    borderRadius: 6,
  },
  '& .MuiTablePagination-actions': {
    display: 'flex',
    alignItems: 'center',
    marginLeft: 4,
  },
  '& .MuiTablePagination-actions .MuiIconButton-root': {
    padding: 6,
    color: tokens.inkMuted,
    '&.Mui-disabled': { opacity: 0.35 },
  },
  '& .MuiDataGrid-toolbarContainer': {
    gap: '10px',
    padding: '10px 12px',
    flexWrap: 'wrap',
    borderBottom: `1px solid ${tokens.border}`,
  },
  '& .MuiDataGrid-toolbarContainer .MuiButtonBase-root': {
    border: `1px solid ${tokens.border}`,
    borderRadius: '8px',
    color: tokens.inkMuted,
    textTransform: 'none',
    fontWeight: 600,
    fontSize: 13,
    padding: '6px 12px',
    minHeight: 36,
    backgroundColor: tokens.surface,
    '&:hover': {
      backgroundColor: tokens.bg,
      borderColor: tokens.brown,
      color: tokens.ink,
    },
  },
  '& .MuiDataGrid-overlay': {
    backgroundColor: 'rgba(255,254,251,0.85)',
  },
};

export const quickFilterSx = {
  width: { xs: '100%', sm: 240 },
  '& .MuiOutlinedInput-root': {
    height: 36,
    borderRadius: '8px',
    backgroundColor: tokens.surface,
    fontSize: 13,
    '& fieldset': { borderColor: tokens.border },
    '&:hover fieldset': { borderColor: tokens.brown },
    '&.Mui-focused fieldset': { borderColor: tokens.accent },
  },
  '& .MuiSvgIcon-root': { color: tokens.inkMuted, fontSize: 18 },
  '& input': { padding: '8px 0', color: tokens.ink },
};

export const toolbarRowSx = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.25,
  flexWrap: 'wrap',
  width: '100%',
};
